<template>
  <div class="animation" ref="animation"></div>
</template>

<script>
import animation from '@/mixins/animation';
import spin from '@/assets/animations/mobilescan_tutorial_step4.json';

export default {
  name: 'Spin',
  mixins: [animation],
  props: {
    show: Boolean,
  },
  data: () => ({
    animationData: spin,
    autoPlay: false,
  }),
  watch: {
    show(nv) {
      if (!this.animation) return;

      if (!nv) {
        this.animation.goToAndStop(0);
      }
    },
  },
};
</script>
